module.exports = __webpack_public_path__ + "static/media/logo-black.251bf5c8.svg";